// react icons
import { LiaProjectDiagramSolid } from "react-icons/lia";

const aboutCardData = [
  {
    id: 1,
    icon: <LiaProjectDiagramSolid />,
    title: "Experience",
    desc: "5+ years",
  },
  {
    id: 2,
    icon: <LiaProjectDiagramSolid />,
    title: "Completed",
    desc: "700+ projects",
  },
];

export default aboutCardData;
